<template>
  <div class="container">
    <p class="title">新闻</p>
    <hr>
    <div class="main">
      <div class="flex" v-for="item in newslist" :key="item.index" @click="urlchange('newsdetail',item.id)">
        <img v-show="item.cover" :src="item.cover" alt="">
        <div class="right" :class="{nocover:!item.cover}">
          <p>{{item.title}}</p>
        </div>
      </div>
    </div>
    <p class="title">志愿组织</p>
    <hr>
    <div class="main">
      <div class="flex" v-for="item in zy_org_list" :key="item.index" @click="urlchange('orginazationdetail',item.id)">
        <img v-show="item.img" :src="item.img" alt="">
        <div class="right" :class="{nocover:!item.img}">
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>
    <p class="title">实践阵地</p>
    <hr>
    <div class="main">
      <div class="flex" v-for="item in sj_org_list" :key="item.index">
        <img v-show="item.img" :src="item.img" alt="">
        <div class="right" :class="{nocover:!item.img}">
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>
    <p class="title">政策</p>
    <hr>
    <div class="main">
      <div class="flex" v-for="item in policylist" :key="item.index" @click="urlchange('policydetail',item.id)">
        <img v-show="item.cover" :src="item.cover" alt="">
        <div class="right" :class="{nocover:!item.cover}">
          <p>{{item.title}}</p>
        </div>
      </div>
    </div>
    <p class="title">活动</p>
    <hr>
    <div class="main">
      <div class="flex" v-for="item in tasklist" :key="item.index" @click="urlchange('detail',item.id)">
        <img v-show="item.cover" :src="item.cover" alt="">
        <div class="right" :class="{nocover:!item.cover}">
          <p>{{item.title}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'searchresult',
  data() {
    return {
      newslist:[],
      orglist:[],
      policylist:[],
      tasklist:[],
      zy_org_list:[],
      sj_org_list:[],
    }
  },
  created(){
    console.log(this.$route.query.keyword);
    this.$axios({
      method:'post',
      url:'/api/index/search',
      data:this.qs.stringify({
        keyword:this.$route.query.keyword
      })
    }).then(res => {
      console.log(res.data);
      if(res.data.code == 0){
        this.newslist = res.data.data.news_list;
        this.orglist = res.data.data.org_list;
        this.policylist = res.data.data.policy_list;
        this.tasklist = res.data.data.task_list;
        this.sj_org_list = res.data.data.sj_org_list;
        this.zy_org_list = res.data.data.zy_org_list;
      }else{
        this.$toast(res.data.msg);
      }
    })
  },
  methods:{
    urlchange(url,id){
      this.$router.push({
        name:url,
        query:{
          id:id,
        }
      })
    }
  }
}
</script>
<style scoped>
.title{
  color: grey;
  margin-left: 10px;
}
hr{
  margin: 2px 10px;
  display: block;
}
.flex{
  display: flex;
  padding: 10px;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
}
.main{
  padding: 10px;
}
img{
  width: 35vw;
  height: 25vw;
  object-fit: contain;
  border-radius: 5px;
}
.right{
  width: 62%;
  display:-webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-weight: bold;
}
.nocover{
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/searchresult.vue